import { useState } from "react";
import {
  ResponseGetNoticeResponse,
  NoticeApi,
  RequestGetNoticeRequest,
  NoticeGetAllNoticePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetNotice = () => {
  const [noticeList, setNoticeList] = useState<
    ResponseGetNoticeResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchNotices = async (req: RequestGetNoticeRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: NoticeGetAllNoticePostRequest = {
        req,
      };
      const api = new NoticeApi(config);
      const response = await api.noticeGetAllNoticePost(request);
      setNoticeList(response);
      return response;
    } catch (err: any) {
      setError("お知らせ一覧の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { noticeList, fetchNotices, error, isLoading };
};
